if (!customElements.get('quickview-drawer')) {

class QuickViewDrawer extends HTMLElement {
    constructor() {
        super();
        this.drawerContent = this.querySelector('.content');
        this.contentProduct = this.querySelector('.product-content');
        this.btnCLose = this.querySelector('.js-close');
        this.btnAdd = this.querySelector('.action');
        this.overlay = this.querySelector('.overlay');
        this.loading = this.querySelector('.loading');
        this.event = null;
        this.btnCLose.addEventListener('click', this.closeDrawer.bind(this));
        this.overlay.addEventListener('click', this.closeDrawer.bind(this));
        this.addEventListener('touchstart',this.touchStart.bind(this));
        this.addEventListener('touchmove',this.touchMove.bind(this));
        this.addEventListener('touchend',this.touchEnd.bind(this));
    }
    touchStart(e) {
        this.event = e;
    }
    touchEnd (e) {
       
        this.event = null;
    }
    touchMove(e) {
        if( this.event ) {
           let direction = e.touches[0].pageY - this.event.touches[0].pageY;
           if(direction > 0 && direction > 200) {
            this.closeDrawer();
           }
        }
        
    }

    initHandle () {
        this.productMedia = this.querySelector('.product-media');
        this.productInfo = this.querySelector('.product-block-content');
        this.formBtn = this.querySelector('.add-btn');
        
    }
    clearPopup() {
        this.productMedia = this.querySelector('.product-media');
        this.productInfo = this.querySelector('.product-block-content');
        if(this.productMedia != null) {
            this.productMedia.remove();
            this.productInfo.remove();
            this.formBtn.remove();
        }
        this.loading.style.display = 'block';



    }
    renderProduct(productHandle) {
  this.openDrawer();
  this.loading.style.display = 'block';

  fetch(`/products/${productHandle}`)
    .then(res => res.text())
    .then(data => {
      const html = new DOMParser().parseFromString(data, 'text/html');
      const product = html.getElementById('quicview-drawer-content');
      if (!product) return;

      const productInfo = product.querySelector('.product-block-content');
      const addBtn = product.querySelector('.btn__wrap');

      if (addBtn && this.btnAdd) {
        const cleanBtn = addBtn.cloneNode(true);
        this.btnAdd.innerHTML = cleanBtn.innerHTML;
      }

      if (productInfo && this.contentProduct) {
        this.contentProduct.innerHTML = productInfo.innerHTML;
      }
    })
    .catch(error => {
      console.error('QuickView error:', error);
    })
    .finally(() => {
      this.initHandle();
      this.loading.style.display = 'none';
    });
}


    openDrawer() {
    this.classList.add('active');
    // ❌ DO NOT LOCK BODY SCROLL
}

    closeDrawer() {
    this.classList.remove('active');
    this.clearPopup();

    // HARD UNLOCK (no conditions)
    document.body.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("overflow");
    $("body, html").css("overflow", "");
}



}

customElements.define('quickview-drawer', QuickViewDrawer);
}